/**
 * Test ID utilities for Dialog component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Dialog trigger
 * @param identifier - Dialog identifier
 * @returns Test ID string
 */
export const setDialogTriggerTestId = (identifier: string): string =>
  generateTestId(
    "DialogTrigger",
    identifier.replace(/\s+/g, "-").toLowerCase(),
  );

/**
 * Generate test ID for Dialog content
 * @param identifier - Dialog identifier
 * @returns Test ID string
 */
export const setDialogContentTestId = (identifier: string): string =>
  generateTestId(
    "DialogContent",
    identifier.replace(/\s+/g, "-").toLowerCase(),
  );

/**
 * Generate test ID for Dialog title
 * @param identifier - Dialog identifier
 * @returns Test ID string
 */
export const setDialogTitleTestId = (identifier: string): string =>
  generateTestId("DialogTitle", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for Dialog description
 * @param identifier - Dialog identifier
 * @returns Test ID string
 */
export const setDialogDescriptionTestId = (identifier: string): string =>
  generateTestId(
    "DialogDescription",
    identifier.replace(/\s+/g, "-").toLowerCase(),
  );

/**
 * Generate test ID for Dialog close button
 * @param identifier - Dialog identifier
 * @returns Test ID string
 */
export const setDialogCloseTestId = (identifier: string): string =>
  generateTestId("DialogClose", identifier.replace(/\s+/g, "-").toLowerCase());
